import { render } from "./PolicyReviewEditOnboardComponent.vue?vue&type=template&id=28fcb4ac"
import script from "./PolicyReviewEditOnboardComponent.vue?vue&type=script&lang=js"
export * from "./PolicyReviewEditOnboardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__